import type { MinimizableModalView, MinimizableModalProps } from '../../types.tsx';

/**
 * This should be an enum, unfortunately
 * the current version of flow used does not
 * support it, so instead is it going to be a constant
 */
export type TransitionStateEnum = 1 | 2 | 3;
type TransitionStateType = {
	[key: string]: TransitionStateEnum;
};

export const TransitionState: TransitionStateType = {
	EXITED: 1,
	ENTERED: 2,
	TRANSITIONING: 3,
};

export type Context = {
	shouldFocusChanger: boolean;
	view: MinimizableModalView;
	setView: (view: MinimizableModalView, force?: boolean) => void;
	previousView: MinimizableModalView;
	unminimizeModal: (fallbackView: MinimizableModalView) => void;
	onClose: MinimizableModalProps['onClose'];
	// When GIC transitions from one view to another by focusing in a changer button and pressing Enter/Space
	transitionByKeyboardFrom: MinimizableModalView | null;
	setTransitionByKeyboardFrom: (isEnterPressed: MinimizableModalView | null) => void;
	setShouldFocusChanger: (hasTransitioned: boolean) => void;
	isTransitionInState: (
		view: MinimizableModalView[],
		state: TransitionStateEnum,
		fallbackForReducedMotion?: boolean,
	) => boolean;
	setTransitionState: (view: MinimizableModalView, state: TransitionStateEnum) => void;
	shouldDisableViewChangerButtons: boolean;
	customDisabledViewChangerButtonsMessage: string;
	setShouldDisableViewChangerButtons: (
		shouldDisableViewChangerButtons: boolean,
		customDisabledViewChangerButtonsMessage?: string,
	) => void;
	isNestedModal: boolean;
	setIsNestedModal: (isNestedModal: boolean) => void;
	displayMinimizableButtons: boolean;
};
